import { ChangeDetectionStrategy, Component, ElementRef, HostBinding, Input, TemplateRef, ViewChild } from "@angular/core";
import { SpsActionDescriptor, SpsIcon } from "@spscommerce/ds-shared";
import { AttributePresenceInput } from "@spscommerce/ng-utils";

@Component({
    selector: "sps-dropdown-option",
    templateUrl: "./sps-dropdown-option.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpsDropdownOptionComponent implements SpsActionDescriptor {
    static readonly displayName = "sps-dropdown-option";
    static readonly props = {
        icon: "SpsIcon",
        disabled: "boolean",
        href: "string",
    };

    @Input() icon: SpsIcon;
    @Input() @AttributePresenceInput() disabled: boolean;
    @Input() href: string;

    @HostBinding("class.d-none") readonly _dNoneClass = true;

    @ViewChild("template", { static: false }) template: TemplateRef<any>;

    constructor(private _elementRef: ElementRef) {}

    activate() {
        this._elementRef.nativeElement.click();
    }
}
